import { createSlice } from '@reduxjs/toolkit';
import { tours } from 'shared/utils/tours';


const tourKeys = tours.reduce((acc, val) => (
    {...acc, [val.tour]: false}
), {})

const storedTours = localStorage.getItem('tours');
const storedToursObj = storedTours ? JSON.parse(storedTours) : {};
const initialState = {...tourKeys, ...storedToursObj};


const tour = createSlice({
    name: 'tour',
    initialState,
    reducers: {
        finishTour: (state, action) => {
            const tourKey =  action.payload;
            state[tourKey] = true;
            localStorage.setItem('tours', JSON.stringify(state));
        },
        resetTours: (state) => {
            state = {...tourKeys};
            localStorage.setItem('tours', JSON.stringify(state));
        },
    },
});
export default tour.reducer;

export const { finishTour, resetTours } = tour.actions;


